import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const getAddress = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    `/api/resource/Address?fields=["name","disabled","address_title","custom_area","city"]`
  );
  return data;
});
export const getAddressDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Address/${id}`);
  return data;
});
export const addAddress = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(`/api/resource/Address`, body);
  return data;
});
export const updateAddress = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(`/api/resource/Address/${id}`, body);
  return data;
});
export const deleteAddress = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(`/api/resource/Address/${id}`);
  return data;
});
